import { render, staticRenderFns } from "./QDFM.vue?vue&type=template&id=3ffce688&scoped=true&"
import script from "./QDFM.vue?vue&type=script&lang=js&"
export * from "./QDFM.vue?vue&type=script&lang=js&"
import style0 from "./QDFM.vue?vue&type=style&index=0&id=3ffce688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffce688",
  null
  
)

export default component.exports